'use client';

import { FC } from 'react';
import { Breadcrumbs } from 'atoms/Breadcrumbs';
import { useCategoryBreadcrumbs } from 'atoms/Breadcrumbs/hooks';
import { useClothesFinderWizardStore } from 'pages/StoryBlok/ClothesFinder/store';
import { useGiftFinderStore } from 'pages/StoryBlok/Finders/store';
import { PageType } from 'modules/stroyblok/types';
import { ClientPageType } from 'src/app/types';

type CategoryBreadcrumbsProps = {
  pageName: string;
  pageType: PageType;
};

export const CategoryBreadcrumbs: FC<CategoryBreadcrumbsProps> = ({
  pageName,
  pageType,
}) => {
  const contentPage = pageType === ClientPageType.CONTENT;
  const finderPage = pageType === ClientPageType.FINDER;
  let { categories: breadcrumbItems } = useCategoryBreadcrumbs(pageName);
  const giftFinderStore = useGiftFinderStore();
  const clothesFinderWizardStore = useClothesFinderWizardStore();

  const resetFinderWizard = () => {
    if (!finderPage) {
      return null;
    }

    let finderStore;

    if (pageName === 'Dessous-Finder') {
      finderStore = clothesFinderWizardStore;
    } else {
      finderStore = giftFinderStore;
    }

    return finderStore.setCurrentStep(1);
  };

  if (contentPage) {
    breadcrumbItems = [{ title: pageName }];
  }

  return !breadcrumbItems?.length ? null : (
    <Breadcrumbs
      items={breadcrumbItems}
      nonStaticPage
      pageType={pageType}
      onCurrentItemClick={finderPage ? resetFinderWizard : undefined}
    />
  );
};
